/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {Docs} from 'components/layout';
import {getIntegrations} from 'api/get-integrations';
import {getExtensions} from 'api/get-extensions';
import {Warning, Tip, Info, WhitelistDetails} from 'ui';
export const lastUpdatedDate = new Date(1669593600000);
export async function getStaticProps() {
  const integrations = await getIntegrations();
  const extensions = await getExtensions();
  return {
    props: {
      ...integrations,
      extensions,
      meta: {
        title: null,
        description: null,
        lastUpdatedDate: "Mon Nov 28 2022 00:00:00 GMT+0000 (Coordinated Universal Time)",
        slug: "totango",
        type: "destination",
        icon: null,
        toc: [{
          "value": "Setup",
          "depth": 0,
          "id": "setup"
        }, {
          "value": "Service ID",
          "depth": 1,
          "id": "service-id"
        }, {
          "value": "API key",
          "depth": 1,
          "id": "api-key"
        }, {
          "value": "Supported modes",
          "depth": 0,
          "id": "supported-modes"
        }]
      }
    },
    revalidate: 60
  };
}
const MDXLayout = ({children, ...props}) => _jsx(Docs, Object.assign({}, props, {
  children: children
}));
function MDXContent(props = {}) {
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, {})
  })) : _createMdxContent();
  function _createMdxContent() {
    const _components = Object.assign({
      h2: "h2",
      p: "p",
      h3: "h3",
      img: "img",
      ul: "ul",
      li: "li",
      strong: "strong"
    }, _provideComponents(), props.components);
    return _jsxs(_Fragment, {
      children: [_jsx(_components.h2, {
        id: "setup",
        children: "Setup"
      }), "\n", _jsx(_components.p, {
        children: "To configure your Totango destination you will need to provide the following information: Service ID and API Key."
      }), "\n", _jsx(_components.h3, {
        id: "service-id",
        children: "Service ID"
      }), "\n", _jsx(_components.p, {
        children: "To find your Service ID, you'll need to go to the upper right hand corner of the Totango dashboard, which is your profile picture. It will be listed at the bottom of the small context window that pops up."
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-totango-service-id-1.png",
          alt: ""
        })
      }), "\n", _jsx(_components.p, {
        children: "Your service ID is listed as a string which we only need one part. In the screenshot above, the full service ID is 'SP-229775-0'. We will only need the middle part of the ID to authenticate with Totango. Using the example provided, you would only need to use '229775' when filling out the destination details on the Hightouch destination setup page."
      }), "\n", _jsx(_components.h3, {
        id: "api-key",
        children: "API key"
      }), "\n", _jsx(_components.p, {
        children: "To find your API Key, you'll need to go back to your profile picture."
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-totango-profile-1.png",
          alt: ""
        })
      }), "\n", _jsx(_components.p, {
        children: "When you click it, you will want to go to 'Edit profile'."
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-totango-profile-2.png",
          alt: ""
        })
      }), "\n", _jsx(_components.p, {
        children: "Once in your profile you'll want to go to the 'Integrations' page."
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-totango-profile-3.png",
          alt: ""
        })
      }), "\n", _jsx(_components.p, {
        children: "On the Integrations you will find your API Token Key. You will use this key when filling out the destination details on the Hightouch destination setup page."
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-totango-profile-4.png",
          alt: ""
        })
      }), "\n", _jsx(_components.h2, {
        id: "supported-modes",
        children: "Supported modes"
      }), "\n", _jsx(_components.p, {
        children: "The Totango destination supports the upsert mode:"
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsxs(_components.li, {
          children: [_jsx(_components.strong, {
            children: "Upsert"
          }), ": Upsert mode pushes new accounts or account users to Totango and updates fields that change in your warehouse."]
        }), "\n"]
      })]
    });
  }
}
export default MDXContent;
